





































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapGetters({
      username: 'getUsername',
    }),
  },
  props: {
    datosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    datos: [],
    unidad: {},
  }),
  methods: {
    async EditarUnidad() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.unidad = this.datos[0];
        this.unidad.lastModificationUsername = this.username;
        this.unidad.lastModificationDateTime = this.$moment().format();
        const datos = {admin, condo, unidad: this.unidad};
        const result = await this.$store.dispatch('updateUnidad', datos);
        console.log('EditarUnidad result: ', result.data);
        this.openDialog = false;
        this.$toast.success('Unidad Modificada');
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.datos = Array.from(this.datosInit);
      } else {
        this.datos = Array.from([]);
      }
    },
  },
});
